/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formtype_Label1Inputs */

const ja_contact_formtype_label1 = /** @type {(inputs: Contact_Formtype_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせの種類`)
};

const en_contact_formtype_label1 = /** @type {(inputs: Contact_Formtype_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What would you like to enquire about?`)
};

/**
* | output |
* | --- |
* | "What would you like to enquire about?" |
*
* @param {Contact_Formtype_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formtype_label1 = /** @type {((inputs?: Contact_Formtype_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formtype_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formtype_label1(inputs)
	return en_contact_formtype_label1(inputs)
});
export { contact_formtype_label1 as "contact_formType_label" }